import { userService } from "../services";
import router from "../router";
import docCookies from "../helpers/cookies";

// get user if is stored in local storage
const user = JSON.parse(localStorage.getItem("user"));

// get for token if is stored in cookies (boolean) && and for user in local storage
const token = !!docCookies.getItem("token") && !!localStorage.getItem('user');

// set init state
const state = user
  ? { status: { loggedIn: true }, user, token: token }
  : { status: {}, user: {}, token: token };

// ACTIONS
const actions = {

  LOGIN({ commit }, options) {
    // triger mutation -> loading = true
    commit("loginRequest", { username: options.username });
    return new Promise((resolve, reject) => {
      userService.login(options).then(
        response => {

          if (
            response.status == 200 &&
            response.data.token
          ) {
            // store token in cookies
            // docCookies.setItem(name, value[, end[, path[, domain[, secure]]]])
            docCookies.setItem("token", response.data.token, 172800, "/");// 48h

            // set user data in local storage
            localStorage.setItem("user", JSON.stringify(response.data.user));

            // check if there is stored requestUrl in localstorage
            let toBeRoutedTo = localStorage.getItem("requestedURL") ? localStorage.getItem("requestedURL") : "/accept-protocols";

            // requestedURL not needed anymore and it could be delted
            localStorage.removeItem("requestedURL")

            commit("loginSuccess", response.data.user);
            router.push(toBeRoutedTo);
            resolve(true);
          }

        },
        error => {
          commit("loginFailure", error);
          reject(error);
        }
      );
    });
  },

  // log user out
  logout({ commit }) {
    // redirect to login page
    return new Promise((resolve, reject) => {
      userService.logout().then(
        () => {
          commit("logout");
        },
        error => {
          commit("loginFailure", error);
          reject(error);
        }
      );
    });
  }
};

// MUTATIONS
const mutations = {
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, user) {
    state.status = { loggedIn: true };
    state.user = user;
    state.token = true;
  },
  loginFailure() {
    state.status = {};
    state.user = null;
    state.token = false;
    docCookies.removeItem("token");
    localStorage.removeItem("user");
  },
  logout(state) {
    state.status = {};
    state.user = null;
    state.token = false;
    docCookies.removeItem("token", "/");
    localStorage.removeItem("user");
    router.push({
      name: "login"
    });
  }
};

// GETTERS
const getters = {
  isLoggedIn: state => state.token,
  loggedUser: state => state.user
};

// EXPORT
export const account = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
